module.exports = __webpack_public_path__ + "images/47aca59be74c7f446e17b1dfb1802610.svg";